import React, { useCallback, useEffect, useRef, useState } from "react";
import { FocusSDK, isFocusEnv } from "@/utils";
import styles from "./index.module.less";
import IconFont from "@/components/icon";
import Dayjs from "dayjs";
import Bus from "@/utils/bus";
import ImService from "@/server/ImService";
import colors from "@/components/styles/colors";
import { analysisLog } from "@/utils/logAnalytics";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
export default function TaskNoticeCard({
  params,
  closeCurWindow,
  winTimer
}: {
  params: any;
  closeCurWindow: Function;
  winTimer: number;
}) {
  const {
    taskId = "",
    sessionId = "",
    msgTitle = "",
    endTime = "",
    taskName = "",
    deepLink = ""
  } = params;
  const mid = Number(params?.mid || "");
  const [isForceLogout, setIsForceLogout] = useState(false);
  const wtimer = useRef<any>(null);

  const closeNoticeCard = useCallback(() => {
    if (isFocusEnv()) {
      closeCurWindow?.();
    }
  }, [closeCurWindow]);

  function getTaskMsgTitle() {
    const titleDom = (
      <span>
        任务提醒
        {msgTitle && ": "}
        {msgTitle && <span style={{ color: "#EF644F" }}>{msgTitle}</span>}
      </span>
    );
    return titleDom;
  }

  const viewDetail = useCallback(() => {
    if (!isFocusEnv()) {
      return;
    }
    analysisLog("Xtbg_Task_ForcedPopup", "Details");
    if (!isForceLogout) {
      // 发送消息到桌面端
      analysisLog("xtbg_add_task", "xtbg_add_task_remind");
      DeeplinkEvent.open(deepLink, { source: "imShareCard", chat: true });
      FocusSDK.sendIpcMessage("showMainwindow");
    }
    // tj: 已被踢出后直接关闭
    closeNoticeCard();
  }, [isForceLogout, closeNoticeCard, deepLink]);

  const readHandle = useCallback(async () => {
    analysisLog("Xtbg_Task_ForcedPopup", "Close");
    if (ImService.getInstance()) {
      // const _mid = Number(mid || '');
      // const _sessionId = sessionId || '';
      if (!isNaN(mid) && sessionId) {
        await ImService.getInstance().readMessageById(mid, sessionId);
      }
    }
    closeNoticeCard();
  }, [closeNoticeCard, mid, sessionId]);

  // tj: 强制退出 (解决强制退出后点击提醒页面卡死)
  const forceQuitListener = useCallback(() => {
    setIsForceLogout(true);
  }, []);

  useEffect(() => {
    Bus.on("chat:force_quit", forceQuitListener);
    return () => {
      Bus.off("chat:force_quit", forceQuitListener);
    };
  }, [forceQuitListener]);

  // 定时关闭
  useEffect(() => {
    if (winTimer) {
      wtimer.current = setTimeout(() => {
        analysisLog("Xtbg_Task_ForcedPopup", "AutoClose");
        closeNoticeCard();
      }, winTimer * 60 * 1000);
    }
    return () => {
      wtimer.current && clearTimeout(wtimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles["task-notice-card"]}>
      {/* <div className={styles["snc-spliter"]} /> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1
        }}
      >
        <div style={{ flex: 1, padding: "8px 16px 0" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between"
            }}
          >
            <IconFont
              className={styles["scn-primary"]}
              style={{ fontSize: 20 }}
              type="iconic-pc-task"
            />
            <p
              style={{
                flex: 1,
                fontSize: 14,
                color: `${colors.black2}`,
                marginLeft: 10
              }}
            >
              {getTaskMsgTitle()}
            </p>
            <IconFont className={styles["scn-close"]} type="iconty_close" onClick={readHandle} />
          </div>
          <p className={styles["snc-content"]}>
            <label>主题：</label>
            <span className={styles["snc-content-title"]}>{taskName}</span>
          </p>
          <p className={styles["snc-content"]}>
            <label>截止时间：</label>
            {endTime ? Dayjs(Number(endTime)).format("YYYY年M月D日 HH:mm") : "无截止时间"}
          </p>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10 }}>
          <p className={styles["snc-btn"]} onClick={viewDetail}>
            查看详情
          </p>
          <p className={styles["snc-btn-primary"]} onClick={readHandle}>
            关闭
          </p>
        </div>
      </div>
    </div>
  );
}
